export const BUNITO_DONE_REQUEST = "BUNITO_DONE_REQUEST";
export const BUNITO_DONE_SUCCESS = "BUNITO_DONE_SUCCESS";
export const BUNITO_DONE_FAILED = "BUNITO_DONE_FAILED";